import React, {useEffect, useState} from "react";
import "./PerformedActions.css"
import {Bounce, toast} from "react-toastify";
import Chip from "../Chip/Chip";
import {useAddPerformedActions} from "../../hooks/Technician/useAddPerformedActions";

interface PerformedActionsProps {
    onBack: () => void;
    ticketPerformedActions: string [];
    ticketUniqueCode: string;
    updatePerformedActionsLocally: (newPerformedActions: string []) => void;
}

export const PerformedActions: React.FC<PerformedActionsProps> = ({
                                                                      onBack,
                                                                      ticketPerformedActions,
                                                                      ticketUniqueCode,
                                                                      updatePerformedActionsLocally
                                                                  }) => {

    const [newPerformedAction, setNewPerformedAction] = useState("");
    const [performedActions, setPerformedActions] = useState<any>([]);

    const validateField = (field: any, regex: any, errorMessage: any) => {
        if (!regex.test(field)) {
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return false;
        }
        return true;
    };

    const {addActions, savingActions} = useAddPerformedActions();

    useEffect(() => {
        setPerformedActions(ticketPerformedActions)
    }, [ticketPerformedActions]);

    const addPerformedAction = () => {
        if (!validateField(newPerformedAction, /^.{1,100}$/, "La acción realizada no puede exceder los 100 caracteres ni estar vacía.")) return;
        setPerformedActions((prevActions: any) => [...prevActions, newPerformedAction]);
        setNewPerformedAction("");
    }

    const handleRemoveEquipment = (toBeRemoved: number) => {
        setPerformedActions((prevActions: any) =>
            prevActions.filter((existingAction: any) => existingAction !== toBeRemoved)
        );
    };

    const savePerformedActions = () => {
        addActions(performedActions, ticketUniqueCode).then(() => {
            toast.success('¡Acciones guardadas correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            updatePerformedActionsLocally(performedActions)
        }).catch(() => {
            toast.error("Error al guardar acciones", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        })
    }

    return (
        <div>
            {
                savingActions ?
                    (
                        <div className="loading-overlay">
                            <div className="spinner"></div>
                            <div className="loading-message">
                                Guardando
                            </div>
                        </div>
                    ) :
                    (
                        <div>
                            <div className="clients-info-view-header">
                                <button onClick={onBack}>REGRESAR</button>
                                <div className="clients-info-view-header-title">
                                    <p>ACCIONES</p>
                                </div>
                                <span className="material-icons-outlined icon-unselected"
                                      onClick={savePerformedActions}>
                    save
                </span>
                            </div>
                            <div className="performed-actions-body">
                                <div className="performed-action-option">
                                    <label htmlFor="performedAction">¿Qué se hizo?</label>
                                    <input
                                        id="performedAction"
                                        value={newPerformedAction}
                                        onChange={(e) => setNewPerformedAction(e.target.value)}/>
                                </div>
                                <div className="bottom-buttons">
                                    <button className={`confirm ${!newPerformedAction ? 'disabled' : ''}`}
                                            onClick={addPerformedAction}
                                            disabled={!newPerformedAction}>
                                        Añadir
                                    </button>
                                </div>

                                <div className="actions-header">
                                    <p>ACCIONES REALIZADAS</p>
                                </div>
                                <div className="actions-chips">
                                    {performedActions.map((action: any) => (
                                        <Chip
                                            key={action}
                                            text={action}
                                            onRemove={() => handleRemoveEquipment(action)}
                                        />))}
                                </div>
                            </div>
                        </div>
                    )
            }
        </div>
    );
};

export default PerformedActions;